import { CheckCircle2, ShieldCheck, Award, Phone } from "lucide-react";
import { EstimateForm } from "@/components/EstimateForm";
import { PayLaterBanner } from "@/components/PayLaterBanner";
import { PayLaterMessage } from "@/components/PayLaterMessage";
import { PHONE, PHONE_HREF } from "@/data/site";
import { Seo } from "@/components/Seo";

const TRUST_POINTS = [
  { icon: CheckCircle2, text: "Free Estimate" },
  { icon: ShieldCheck, text: "3-Year Labor Warranty" },
  { icon: Award, text: "South Florida's Trusted HVAC Experts Since 1998" },
];

export default function EstimateLanding() {
  return (
    <div data-testid="estimate-landing-page" className="min-h-screen bg-brand-subtle">
      <Seo title="Free AC Replacement Estimate | Central Air Depot" description="Get a free AC replacement estimate in minutes — send photos, no appointment needed. Financing and PayPal Pay Later options available." />
      <header className="bg-brand-ink text-white">
        <div className="max-w-3xl mx-auto px-4 py-12 sm:py-16 text-center">
          <img src="/logo-horizontal.webp" alt="Central Air Depot" data-testid="landing-logo"
            className="h-16 sm:h-20 w-auto mx-auto" />
          <h1 data-testid="landing-headline" className="text-4xl sm:text-5xl lg:text-6xl tracking-tighter leading-none font-black mt-8">
            Get Your Free AC Replacement Estimate in Minutes — No Appointment Needed.
          </h1>
          <div data-testid="landing-trust-row" className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8 mt-8">
            {TRUST_POINTS.map((t) => (
              <span key={t.text} className="flex items-center gap-2 text-sm font-bold text-brand-ice">
                <t.icon className="w-5 h-5 shrink-0" /> {t.text}
              </span>
            ))}
          </div>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-4 py-12 sm:py-16 space-y-6">
        <EstimateForm />
        <PayLaterMessage />
        <PayLaterBanner />
      </main>

      <footer className="bg-brand-ink text-white">
        <div className="max-w-3xl mx-auto px-4 py-8 text-center">
          <p data-testid="landing-phone-line" className="text-sm text-blue-100">
            Prefer to talk it through? Call us any time —{" "}
            <a href={PHONE_HREF} data-testid="landing-phone-link" className="font-heading font-bold text-white inline-flex items-center gap-1.5 hover:text-brand-ice transition-colors duration-200">
              <Phone className="w-4 h-4" /> {PHONE}
            </a>
          </p>
        </div>
      </footer>
    </div>
  );
}
